import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import { defaults, footerStyle } from '../shared/default'
import { sharedStyles } from '../shared/shared_styles'
import { ImpactGoaSlideContent } from './impact_goal_slide'
import type {
  ImpactGoalType,
  CompanyInfoType,
  ImpactSummaryType,
} from '~/types/types'

pdfMake.vfs = pdfFonts.pdfMake.vfs
pdfMake.fonts = {
  Roboto: {
    normal: 'Roboto-Regular.ttf',
    medium: 'Roboto-Medium.ttf',
    italics: 'Roboto-Italic.ttf',
    mediumitalics: 'Roboto-MediumItalic.ttf',
    bold: 'Roboto-Medium.ttf',
  },
}

export const docDefinition = (
  impact: ImpactGoalType,
  companyInfo: CompanyInfoType,
  impactSummary: ImpactSummaryType,
  locale = 'en',
  chartSvg?: string | null,
) => {
  return {
    pageSize: 'A4',
    ...defaults('Impact'),
    content: [
      ImpactGoaSlideContent(impact, companyInfo, impactSummary, locale, chartSvg),
    ],
    ...{
      styles: {
        ...sharedStyles,
        ...footerStyle,
      },
    },
  }
}

export default class ImpactDashboard {
  constructor(
    impact: ImpactGoalType,
    companyInfo: CompanyInfoType,
    impactSummary: ImpactSummaryType,
    locale: string,
    chartSvg?: string | null,
  ) {
    // eslint-disable-next-line no-console
    pdfMake
      .createPdf(docDefinition(impact, companyInfo, impactSummary, locale, chartSvg))
      .download(`${companyInfo?.ventureName}_Impact profile`)
  }
}
